import { AdminImageCropInput, AdminInput, Div, P } from '@vgrubs/components';

/**
 * A group's photo and name, the way both the create form and the details panel
 * ask for them: the picture above, larger, with the name centred underneath.
 * The same shape the menu's Add Item screen uses, minus its AI generator.
 *
 * Read-only when the viewer cannot manage the group - the fields are replaced
 * by the values rather than disabled, since a greyed-out input in a panel you
 * opened to read is just noise.
 */
export const GroupIdentityFields = ({
  title,
  onTitleChange,
  onTitleBlur,
  image,
  onImageChange,
  onImageDelete,
  canManage = true,
  placeholder,
}: {
  title: string;
  onTitleChange: (title: string) => void;
  /** Where the details panel saves; the create form has a button instead. */
  onTitleBlur?: () => void;
  image: File | Blob | string | null;
  onImageChange: (image: File | Blob | string | null) => void;
  onImageDelete?: () => void;
  canManage?: boolean;
  placeholder?: string;
}) => (
  <>
    <Div $flex $column $center $mb="24">
      <AdminImageCropInput
        image={image}
        onChange={onImageChange}
        onDelete={canManage ? onImageDelete : undefined}
        noChange={!canManage}
        shape="circle"
        width="180px"
        textCenter
        /* No `placeholder`: that prop is a COMPONENT, and the string "Photo"
           passed here was rendered as <Photo />, an unknown element that draws
           nothing - which is why an unset group photo was a blank white disc.
           Left off, it falls back to the app's own image placeholder icon. */
      />
    </Div>

    <Div $mb="24">
      {canManage ? (
        <AdminInput
          label="Group Name"
          placeholder={placeholder}
          value={title}
          maxLength={120}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onTitleChange(event.target.value)
          }
          onBlur={onTitleBlur}
          $textCenter
        />
      ) : (
        <P $m="0" $bold $center>
          {title}
        </P>
      )}
    </Div>
  </>
);
